import React, { useContext, useEffect, useRef, useState } from "react";
import "./style.css";
import Table from "../Tables";
import { useLocation } from "react-router-dom";
import { PrivilegeContext } from "../../../context/PrivilegesContext";
import { DomainContext } from "../../../context/DomainContext";
import { TableSkeleton } from "../Tables/Components/Skeleton";
import { useGenerateSearchFields } from "./Hooks/useGenerateSearchFields";
import ReportTitle from "./ReportTitle";
import { useGetTableData } from "./Hooks/useGetTableData";

const ReportContent = ({ children, tableAPI, columns }) => {

  const [tableFiller, setTableFiller] = useState({ pageSize: 25, page: 0 });

  const { hiddenColumnsList } = useGenerateSearchFields(columns)

  const { dataLoading } = useContext(DomainContext);


  const { data, totalRows } = useGetTableData(tableAPI, tableFiller)

  const { privileges } = useContext(PrivilegeContext);


  return (
    <div className="pages-wrapper">

      {/*  <ReportTitle /> */}
      {children}
    {/**/}
      <Table
        isLoading={dataLoading}
        columns={columns}
        data={data}
        isNeedFetch={false}
        setTableFiller={setTableFiller}
        tableFiller={tableFiller}
        TotalRows={totalRows}
        hiddenColumns={hiddenColumnsList}
        hideActions={!privileges?.canDelete && !privileges?.canEdit}
      />

      <TableSkeleton isLoading={dataLoading} />

    </div>
  );
};

export default ReportContent;
